var $34814b16b3542f90$exports = {};
function $34814b16b3542f90$var$shuffle(array) {
    let currentIndex = array.length;
    while(currentIndex !== 0){
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
}
const $34814b16b3542f90$var$parent = document.getElementById('quotes');
const $34814b16b3542f90$var$article = $34814b16b3542f90$var$parent.querySelector('article');
const $34814b16b3542f90$var$quotes = [
    ...$34814b16b3542f90$var$article.children
];
$34814b16b3542f90$var$shuffle($34814b16b3542f90$var$quotes);
$34814b16b3542f90$var$article.innerHTML = '';
let $34814b16b3542f90$var$fragment = document.createDocumentFragment();
const $34814b16b3542f90$var$half = Math.ceil($34814b16b3542f90$var$quotes.length / 2);
for(let i = 0; i < $34814b16b3542f90$var$half; i++)$34814b16b3542f90$var$fragment.appendChild($34814b16b3542f90$var$quotes[i]);
$34814b16b3542f90$var$article.appendChild($34814b16b3542f90$var$fragment);
const $34814b16b3542f90$var$second = document.createElement('article');
$34814b16b3542f90$var$second.classList.add('quote-section', 'reverse');
for(let i = $34814b16b3542f90$var$half; i < $34814b16b3542f90$var$quotes.length; i++)$34814b16b3542f90$var$second.appendChild($34814b16b3542f90$var$quotes[i]);
$34814b16b3542f90$var$parent.appendChild($34814b16b3542f90$var$second);


//# sourceMappingURL=delta-website.e16c29f1.js.map
